(() => {
  const script = document.currentScript;
  const page = document.body.dataset.dhListicle;
  if (!['A', 'B'].includes(page)) return;
  const links = [...document.querySelectorAll('[data-dh-listicle-link]')];
  const query = new URLSearchParams(location.search);
  links.forEach(link => {
    const target = new URL(link.getAttribute('href'), location.origin);
    query.forEach((value, key) => { if (/^utm_/i.test(key) || ['fbclid','gclid','preview_theme_id'].includes(key)) target.searchParams.set(key,value); });
    target.searchParams.set('utm_term',link.dataset.dhListicleLink);
    link.href = target.pathname + target.search + target.hash;
  });
  const events = [];
  let metaLoaded = false;
  const marketingAllowed = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const analyticsAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const meta = () => {
    if (typeof window.fbq === 'function') return window.fbq;
    if (metaLoaded || !marketingAllowed()) return null;
    const pixel = script?.dataset.metaPixel;
    if (!/^\d+$/.test(pixel || '')) return null;
    const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq,arguments) : fbq.queue.push(arguments); };
    fbq.queue=[];fbq.loaded=true;fbq.version='2.0';fbq.push=fbq;
    window.fbq=fbq;window._fbq=window._fbq || fbq;
    fbq('init',pixel);
    const loader=document.createElement('script');loader.async=true;loader.src='https://connect.facebook.net/en_US/fbevents.js';document.head.appendChild(loader);
    metaLoaded=true;
    return fbq;
  };
  const flush = () => {
    events.forEach(event => {
      if (!event.meta && marketingAllowed()) {
        const fbq=meta();
        if(fbq){fbq('trackCustom',event.name,event.data,{eventID:event.id});event.meta=true;}
      }
      if (!event.clarity && analyticsAllowed() && typeof window.clarity==='function') {
        window.clarity('set','DH_ListiclePage',page);
        if(event.data.link)window.clarity('set','DH_ListicleLink',event.data.link);
        if(event.data.reason)window.clarity('set','DH_ListicleReason',String(event.data.reason));
        window.clarity('event',event.name);event.clarity=true;
      }
      if(!event.shopify && analyticsAllowed() && window.Shopify?.analytics?.publish){window.Shopify.analytics.publish(event.name,event.data);event.shopify=true;}
    });
  };
  const fire = (name,data={}) => {
    const event={name,data:{page,...data},id:crypto.randomUUID(),meta:false,clarity:false,shopify:false};events.push(event);flush();
    document.dispatchEvent(new CustomEvent('dh:listicle-event',{detail:{name,data:event.data}}));
  };
  document.addEventListener('visitorConsentCollected',flush);
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)flush();});
  let attempts=0;const retry=setInterval(()=>{flush();if(++attempts===20)clearInterval(retry);},500);
  fire('DH_ListicleView');
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-dh-listicle-link]');
    if(link)fire('DH_PDPFromListicle',{link:link.dataset.dhListicleLink});
  });
  const reason4=document.querySelector('[data-dh-reason="4"]');
  if(reason4){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){fire('DH_ReasonReached',{reason:4});observer.disconnect();}},{threshold:0});observer.observe(reason4);}
  const sticky=document.querySelector('[data-dh-listicle-sticky]');
  const hero=document.getElementById('dh-listicle-hero');
  let passedHero=false;
  const cookieVisible=()=>{
    const banner=document.getElementById('shopify-pc__banner');
    if(!banner)return false;
    const box=banner.getBoundingClientRect();return box.width>0 && box.height>0 && getComputedStyle(banner).visibility!=='hidden';
  };
  const updateSticky=()=>{if(sticky){const hidden=!passedHero || cookieVisible();if(sticky.hidden!==hidden)sticky.hidden=hidden;}};
  if(sticky && hero){new IntersectionObserver(([entry])=>{passedHero=entry.boundingClientRect.bottom<=0;updateSticky();},{threshold:0}).observe(hero);new MutationObserver(updateSticky).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['style','hidden','class']});}
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const loops = [...document.querySelectorAll('[data-dh-loop]')];
  const fallback = video => {
    if (!video.dataset.fallback || video.dataset.failed) return;
    video.dataset.failed = 'true';
    const image = document.createElement('img');
    image.src = video.dataset.fallback;
    image.alt = video.getAttribute('aria-label') || '';
    image.width = 640; image.height = 640;
    image.className = 'dh-article-image'; image.loading = 'lazy';
    video.replaceWith(image);
  };
  const playLoop = video => {
    if (motion.matches || video.dataset.failed) return;
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    video.muted = true;
    const started = video.play();
    if (started?.catch) started.catch(() => {});
  };
  loops.forEach(video => video.addEventListener('error', () => fallback(video)));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) playLoop(entry.target);
        else entry.target.pause();
      });
    }, {rootMargin:'150px 0px',threshold:0});
    loops.forEach(video => observer.observe(video));
  } else loops.forEach(playLoop);
  motion.addEventListener('change', () => {
    loops.forEach(video => { if (motion.matches) video.pause(); });
  });
})();
